'use client';

import { Box } from '@chakra-ui/react';
import { AppShell, AppShellProps } from '@saas-ui/react';

import { ShellAtmosphere } from '@/components/common/ShellAtmosphere';

/**
 * Base layout for app pages.
 */
export const AppLayout: React.FC<AppShellProps> = ({
  children,
  sidebar,
  ...rest
}) => {
  return (
    <Box
      position='absolute'
      inset={0}
      height='100dvh'
      overflow='hidden'
      bg='app-background'
    >
      <ShellAtmosphere />
      <AppShell h='full' sidebar={sidebar} {...rest}>
        {children}
      </AppShell>
    </Box>
  );
};
